import React from 'react';

const TextArea = ({
    label,
    name,
    value,
    onChange,
    rows = 4,
    placeholder = '',
    error = '',
    required = false,
    disabled = false,
    className = '',
    style = {},
    ...props
}) => {
    return (
        <div style={{ marginBottom: '16px', width: '100%' }}>
            {label && (
                <label
                    htmlFor={name}
                    style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#d1d5db',
                        marginBottom: '6px',
                    }}
                >
                    {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
                </label>
            )}
            <textarea
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                rows={rows}
                placeholder={placeholder}
                required={required}
                disabled={disabled}
                style={{
                    width: '100%',
                    padding: '10px 14px',
                    backgroundColor: '#111827',
                    color: '#f9fafb',
                    border: error ? '1px solid #ef4444' : '1px solid #374151',
                    borderRadius: '8px',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'border-color 0.2s ease-in-out',
                    boxSizing: 'border-box',
                    resize: 'vertical',
                    fontFamily: 'inherit',
                    ...style,
                }}
                className={`textarea-common ${className}`}
                {...props}
            />
            {error && (
                <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px', margin: '4px 0 0 0' }}>
                    {error}
                </p>
            )}
        </div>
    );
};

export default TextArea;
